import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Picture } from "@/components/site/Picture";
import { BRAND, PRIMARY_NAV } from "@/lib/brand";
import { CTAButton } from "./Button";

import { cn } from "@/lib/utils";

export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 transition-all duration-500",
        scrolled
          ? "bg-background/85 backdrop-blur-md border-b border-border"
          : "bg-transparent",
      )}
    >

      <div className="container-edge flex h-20 items-center justify-between gap-6 pt-4">
        <Link to="/" className="flex items-center gap-3" aria-label="Kristan Cole Network home">
          <Picture
            src={BRAND.logos.onDark}
            alt="Kristan Cole Network"
            className="h-20 w-auto"
            width={160}
            height={36}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {PRIMARY_NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="text-sm uppercase tracking-[0.18em] text-foreground/90 hover:text-foreground transition-colors"
              activeProps={{ className: "!text-white font-medium" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <CTAButton
            href={BRAND.links.visibilityAudit}
            size="md"
            variant="outline"
            className="border-foreground text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary"
          >
            Get Your Visibility Audit
          </CTAButton>
        </div>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open ? (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="container-edge py-6 flex flex-col gap-5">
            {PRIMARY_NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.18em] text-foreground/90"
              >
                {item.label}
              </Link>
            ))}
            <CTAButton href={BRAND.links.visibilityAudit} size="md" className="mt-2 w-full">
              Get Your Visibility Audit
            </CTAButton>
            <CTAButton href={BRAND.links.roundTable} variant="outline" size="md" className="w-full">
              Request Round Table Invite
            </CTAButton>
          </div>
        </div>
      ) : null}
    </header>
  );
}
